import { dropBoolean } from 'utils/drops';

const getCrmMotivoDescarteFilterFields = () => [
  { name: 'id', label: 'ID', type: 'number' },
  { name: 'motivo', label: 'Motivo', initial: true },
  { name: 'ativo', label: 'Ativo', type: 'select', options: dropBoolean },
];

export default getCrmMotivoDescarteFilterFields;
